import * as React from "react";
import ActionModal from "../action-modal/action-modal";
import { isResponseOK, defined } from "common/Support";
import { GlideDropdown } from "designer/ui/smart/glide-dropdown/glide-dropdown";
import HighlightTextArea from "sharedUI/ui/smart/highlight-textarea/highlight-textarea";
import { RequestDataExportBody } from "common/firebase-function-types";
import { getAppFacilities } from "webapp/lib/app-renderer";
import { logError } from "common/debug-print";
import { DRMWrapper } from "./data-request-modal-style";
import { showBasicActionModal } from "designer/ui/smart/modals/modals";

type Props = Readonly<{
    header: React.ReactNode;
    choices: string[];
    onAccept: () => void;
    onCancel: () => void;
}>;

type State = Readonly<{
    selected: string;
    additionalInfo: string;
}>;

export default class DataRequestModal extends React.PureComponent<Props, State> {
    public state: State = { additionalInfo: "", selected: "" };

    private onAccept = async () => {
        const { onAccept } = this.props;
        const { selected, additionalInfo } = this.state;
        const body: RequestDataExportBody = {
            exportType: defined(selected),
            additionalInfo: defined(additionalInfo),
        };
        const response = await getAppFacilities().callAuthCloudFunction("requestDataExport", body);
        if (!isResponseOK(response)) {
            logError("Could not set additional Billing info.");
            this.props.onCancel();
        } else {
            await showBasicActionModal("Success", "Data Request has been sent!", "OK");
            onAccept();
        }
        return;
    };

    private onCancel = () => {
        const { onCancel } = this.props;
        onCancel();
    };

    private onItemSelected = (selected: string) => {
        this.setState({ selected });
    };

    private onAdditionalInfoChange = (additionalInfo: string) => {
        this.setState({ additionalInfo });
    };

    public render() {
        const { header, choices } = this.props;
        const { selected, additionalInfo } = this.state;

        const dropdown = (
            <GlideDropdown<string>
                tallerVariation={true}
                items={choices}
                selected={selected}
                descriptionForItem={i => i}
                onItemSelect={this.onItemSelected}
                defaultDisplayLabel="—"
            />
        );
        const textArea = (
            <HighlightTextArea
                autoFocus={true}
                placeholder="Additional Information"
                value={additionalInfo}
                onChange={e => this.onAdditionalInfoChange(e.target.value)}
            />
        );
        const description = (
            <DRMWrapper>
                <div className="margin-wrapper">Submit a formal request under the CCPA or GDPR.</div>
                <div className="margin-wrapper">{dropdown}</div>
                {textArea}
            </DRMWrapper>
        );

        return (
            <ActionModal
                header={header}
                description={description}
                acceptText="Submit"
                cancelText="Cancel"
                acceptAction={this.onAccept}
                cancelAction={this.onCancel}
                acceptDisabled={selected === undefined}
            />
        );
    }
}
